import React, {useState, useEffect, Fragment} from 'react';
import { Container, Row, Col, Button, Input, Card, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, CardTitle, FormGroup, Label, Form } from "reactstrap";
import { Link, Redirect, withRouter } from "react-router-dom";
import {Table, Thead, Tbody, Tr, Th, Td} from 'react-super-responsive-table';
import { paramPost } from "../../apiHelpers/commonApiHelper";

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';

import { connect } from 'react-redux';


import { getPlayer } from '../../store/actions';
import Select from "react-select";
//i18n
import { withNamespaces } from 'react-i18next';
import moment from "moment";
import Dropzone from "react-dropzone";
import { Checkbox, Tooltip } from 'antd';
import toastr from "toastr";
import SweetAlert from "react-bootstrap-sweetalert";





const Screens = (props) => {

    useEffect(() => {
        props.getPlayer()
    }, []);

    const [confirm_both, setconfirm_both] = useState(false);
    const [success_dlg, setsuccess_dlg] = useState(false);
    const [error_dlg, seterror_dlg] = useState(false);
    const [dynamic_title, setdynamic_title] = useState("");
    const [dynamic_description, setdynamic_description] = useState("");

    const [editModal, setEditModal] = useState(false);
    const [pending, setPending] = useState(false);
    const [playerId, setPlayerId] = useState(undefined);
    const [selectedCams, setSelectedCams] = useState([]);

    const [processing, setProcessing] = useState(-1);

    const [id, setId] = useState(undefined);

    const [nameModal, setNameModal] = useState(false);
    const [editPlayerId, setEditPlayerId] = useState("");
    const [editPlayerName, setEditPlayerName] = useState("");
    const [namePending, setNamePending] = useState(false);

    const screenList = () => {
        if (props.screens) {
            return props.screens.map((item, index) => {
                return (
                    <Tr key={index}>
                        <Td>
                            <span className="mr-2">{item.player_name || '—'}</span>
                            <button
                                type="button"
                                className="btn btn-link btn-sm p-0 align-baseline text-primary"
                                onClick={() => openNameModal(item.player_id, item.player_name)}
                            >
                                Rename
                            </button>
                        </Td>
                        <Td>
                            {item.is_online ? <span style={{color: "green"}}>online</span> : item.last_online_at ? moment(item.last_online_at).format("llll") : <span style={{color: "red"}}>offline</span>}
                        </Td>
                        <Td>{item.is_sync ?
                            <i className="far fa-circle" style={{color: "green", fontSize: "20px"}}></i> :
                            <i className="far fa-circle" style={{color: "red", fontSize: "20px"}}></i>

                        }</Td>
                        <Td>
                            <button className="btn capmaign-detail" onClick={() => window.location.href =`/screens/${item.player_id}`}>
                                {item.campaign_count} Campaigns
                            </button>
                        </Td>
                        <Td>
                            <Tooltip title="Publish to screen">
                                <span>
                                    <i className="action-cursor fas fa-arrow-alt-circle-up"
                                       role="button"
                                       tabIndex={0}
                                       onClick={() => handlePublishing(item.player_id)}
                                       onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handlePublishing(item.player_id); }}
                                    />
                                </span>
                            </Tooltip>
                            <Tooltip title="Remove screen">
                                <span className="ml-2">
                                    <i className="action-cursor fas fa-trash-alt text-danger"
                                       role="button"
                                       tabIndex={0}
                                       onClick={() => handleDelete(item.player_id)}
                                       onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleDelete(item.player_id); }}
                                    />
                                </span>
                            </Tooltip>
                        </Td>
                    </Tr>
                );
            });
        }
    };

    const handleDelete = (id) => {
        setId(id);
        setconfirm_both(true);
    }



    const handleRemove = () => {
        paramPost("/api/v1/players/disable", {fb_player_id: id})
            .then((result) => {
                if(result.status === 200) {
                    setsuccess_dlg(true);
                    setdynamic_title("Deleted");
                    setdynamic_description("Screen deleted successfully");
                    props.getPlayer();
                } else {
                    setdynamic_title("Failed");
                    setdynamic_description(result.data.message);
                    seterror_dlg(true);
                }
            })
            .catch(err => {
                setdynamic_title("Error");
                setdynamic_description("Something went wrong. Try again");
                seterror_dlg(true);
            })
    }

    const clear = () => {
        setEditModal(false);
        setPlayerId(undefined);
        setSelectedCams([]);
    }

    const handlePublishing = (player_id) => {
        setPlayerId(player_id);
        setEditModal(true);
    }

    const openNameModal = (player_id, currentName) => {
        setEditPlayerId(player_id);
        setEditPlayerName(currentName || "");
        setNameModal(true);
    }

    const clearNameModal = () => {
        setNameModal(false);
        setEditPlayerId("");
        setEditPlayerName("");
        setNamePending(false);
    }

    const saveDisplayName = () => {
        const trimmed = (editPlayerName || "").trim();
        if (!trimmed) {
            toastr.error("Please enter a display name", "Error");
            return;
        }
        setNamePending(true);
        paramPost("/api/v1/players/update_display_name", { player_id: editPlayerId, player_name: trimmed })
            .then((result) => {
                setNamePending(false);
                if (!result || !result.data) {
                    toastr.error("Request failed", "Error");
                    return;
                }
                if (result.data.success) {
                    toastr.success(result.data.message || "Updated", "Success");
                    clearNameModal();
                    props.getPlayer();
                } else {
                    toastr.error((result.data && result.data.message) || "Update failed", "Error");
                }
            })
            .catch(() => {
                setNamePending(false);
                toastr.error("Something went wrong", "Error");
            });
    }

    const handlePublishingSave = () => {
        setPending(true);
        paramPost('/api/v1/campaigns/publish', {campaigns: selectedCams})
            .then((result) => {
                setPending(false);
                if(result.data.success) {
                    toastr.success("Campaign published successfully", "Success");
                    clear();
                } else {
                    if(result.status === 204) {
                        toastr.info("Campaigns are already published", "Info");
                        return
                    }
                    toastr.error("Something went wrong. Please try again", "Error");
                }
            })
            .catch(err => {
                setPending(false);
                toastr.error("Something went wrong. Please try again", "Error");
            })
    }

    const handleCheckBox = (e, campaignId) => {
        if(e.target.checked && (selectedCams.length === 0 || selectedCams.some(item => item.campaign_id !== campaignId))) {
            setSelectedCams(selectedCams => [...selectedCams, {player_id: playerId, campaign_id: campaignId}]);
        }
        if(!e.target.checked) {
            if(props.screens && props.screens.length === 1) {
                setSelectedCams([]);
            }
            setSelectedCams(selectedCams => [...selectedCams.filter( el => el.campaign_id === campaignId)]);
        }
    }

    const contentList = () => {
        if (props.campaigns) {
            return props.campaigns.map((item, index) => {
                return (
                    <Tr key={index} className="text-left">
                        <Td>
                            <span className="mr-2"><Checkbox onChange={(e) => handleCheckBox(e, item.id)}></Checkbox></span>
                            {item.name}
                        </Td>
                        <Td>
                            {item.media_campaigns[0].medium.media_type === "image" ? (
                                <img src={item.media_campaigns[0].medium.url} style={{width: "85px", height: "60px"}} />
                            ) : item.media_type === "video" ? (
                                <video style={{width: "85px", height: "60px"}}>
                                    <source src={item.media_campaigns[0].medium.url} type="video/mp4" />
                                </video>
                            ) : ""}
                        </Td>
                        <Td>{moment(item.created_at).format("llll")}</Td>
                    </Tr>
                );
            });
        }
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <button className="btn btn-rounded btn-primary mb-3 float-right"
                            onClick={() => window.location.href = "/setup"}
                    >
                        <i className="fas fa-plus"></i> &nbsp;
                       Add Screen
                    </button>
                    <div className="table-rep-plugin">
                        <div
                            className="table-responsive mb-0"
                            data-pattern="priority-columns"
                        >
                            <Table
                                id="tech-companies-1"
                                className="table table-striped table-bordered content-table"
                            >
                                <Thead>
                                    <Tr>
                                        <Th data-priority="1">Display Name</Th>
                                        <Th data-priority="1">Online/Offline</Th>
                                        <Th data-priority="1">In sync</Th>
                                        <Th data-priority="1">Campaign Counts</Th>
                                        <Th data-priority="1">Action</Th>
                                    </Tr>
                                </Thead>

                                {!props.loading && (
                                    <Tbody className="">{screenList()}</Tbody>
                                )}
                            </Table>
                            {props.loading && (
                                <div className="loading-icon">
                                    <i className="fas fa-sync fa-spin"></i>
                                </div>
                            )}
                        </div>
                    </div>
                </Container>
            </div>

            {confirm_both ? (
                <SweetAlert
                    title={"Are you sure?"}
                    warning
                    showCancel
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    onConfirm={() => {
                        setconfirm_both(false);
                        handleRemove();
                    }}
                    onCancel={() => {
                        setconfirm_both(false);
                        setsuccess_dlg(false);
                        setdynamic_title("Cancelled");
                        setdynamic_description("Your imaginary file is safe :)");
                    }}
                >
                    Delete this screen?
                </SweetAlert>
            ) : null}

            {success_dlg ? (
                <SweetAlert
                    success
                    title={dynamic_title}
                    onConfirm={() => {
                        setsuccess_dlg(false);
                    }}
                >
                    {dynamic_description}
                </SweetAlert>
            ) : null}

            {error_dlg ? (
                <SweetAlert
                    error
                    title={dynamic_title}
                    onConfirm={() => {
                        seterror_dlg(false);
                    }}
                >
                    {dynamic_description}
                </SweetAlert>
            ) : null}

            <Modal isOpen={nameModal} toggle={() => clearNameModal()} centered backdrop="static">
                <div className="modal-content">
                    <ModalHeader toggle={() => clearNameModal()}>Edit display name</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label for="editPlayerName">Display name</Label>
                            <Input
                                id="editPlayerName"
                                value={editPlayerName}
                                onChange={(e) => setEditPlayerName(e.target.value)}
                                placeholder="Screen name"
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => clearNameModal()}>Cancel</Button>
                        <Button color="primary" disabled={namePending} onClick={() => saveDisplayName()}>
                            {namePending ? "Saving..." : "Save"}
                        </Button>
                    </ModalFooter>
                </div>
            </Modal>

            <Modal isOpen={editModal} role="dialog" backdrop={"static"} autoFocus={true} centered={true} className="myModal" tabIndex="-1" toggle={() => clear()}>
                <div className="modal-content">
                    <ModalHeader toggle={() => clear()}>
                        Publish Campaign
                    </ModalHeader >
                    <ModalBody>
                        <div className="table-rep-plugin">
                            <div
                                className="table-responsive mb-0"
                                data-pattern="priority-columns"
                            >
                                <Table
                                    id="tech-companies-1"
                                    className="table table-striped table-bordered"
                                >
                                    <Thead>
                                        <Tr>
                                            <Th data-priority="1">Campaign Name</Th>
                                            <Th data-priority="1">File</Th>
                                            <Th data-priority="1">Created At</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody className="">{contentList()}</Tbody>
                                </Table>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" color="secondary" onClick={() => clear()}>Close</button>
                        <button
                            disabled={pending ? true : false}
                            type="button"
                            className="btn btn-primary waves-effect waves-light"
                            onClick={() => handlePublishingSave()}
                        >
                            {pending ? (
                                <React.Fragment>
                                    <i className="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
                                    Publishing...
                                </React.Fragment>
                            ) : "Publish"}
                        </button>
                    </ModalFooter>
                </div>
            </Modal>

        </React.Fragment>
    );
}

const mapStateToProps = state => {
    const { screens, campaigns, loading } = state.ScreenReducer;
    return { screens, campaigns, loading };
}

export default withRouter(connect(mapStateToProps, { getPlayer })(withNamespaces()(Screens)));
